import { Container } from 'ui/elements/LayoutContainer';
import { SanityImage } from 'ui/components/SanityImage';
import { SanityImageObjectType } from 'groq/objects/SanityImageObject';

export type GlossaryPageHeaderProps = {
  headerTitle: string;
  headerIntroduction: string;
  headerBackgroundImage: SanityImageObjectType;
};

export function GlossaryPageHeader(props: GlossaryPageHeaderProps) {
  if (
    !(
      props.headerTitle &&
      props.headerIntroduction &&
      props.headerBackgroundImage
    )
  )
    return null;

  return (
    <Container bleed={true}>
      <section className="bg-white flex flex-col justify-center items-center text-center relative p-8 w-full h-[60vh]">
        <SanityImage source={props.headerBackgroundImage} />
        <div className="relative max-w-screen-md grid gap-[1em]">
          <h1
            data-test-id="glossary-title"
            className="font-bold leading-tight uppercase text-5xl md:text-6xl lg:text-7xl xl:text-8xl"
          >
            {props.headerTitle}
          </h1>
          <p
            data-test-id="glossary-intro"
            className="text-sm md:text-base max-w-[80ch]"
          >
            {props.headerIntroduction}
          </p>
        </div>
      </section>
    </Container>
  );
}
